import { ViewProps } from 'react-native';
import { TeamMemberDataType } from '../../team/view/components/TeamMembersTable';

export interface BasicTeam {
	members: {
		caregivers: TeamMemberDataType[];
	};
	uuid: string;
	name: string;
	subTeams: BasicTeam[];
	parentTeam?: BasicTeam;
}

export type TeamInfoProps = {
	team: BasicTeam;
	activeUuid?: string;
} & Pick<ViewProps, 'style'>;
